<template>
  <div>
    <b-table :class="'table_passages table_passages_' + index_po" responsive small sticky-header sort-by="classement" hover :tbody-tr-class="row_femme" :items="coureurs" :fields="fields" @scroll.native="userScroll" @row-clicked="openFicheCoureur">
      <template #cell(nom)="data"> [{{ data.item.dossard }}] {{ data.item.nom }} {{ data.item.prenom }} </template>
      <template #cell(classement_sexe)="data"> {{ data.item.classement_sex }}{{ data.item.sexe }} </template>
      <template #cell(classement_cat)="data"> {{ data.item.classement_cat }}{{ data.item.categorie }} </template>
      <template #cell(temps_course)="data">
        {{ data.item.temps_course }}
        <span class="diff_time" v-if="sexeFilter == 'M'">{{ data.item.diff_h }}</span>
        <span class="diff_time" v-else-if="sexeFilter == 'F'">{{ data.item.diff_f }}</span>
        <span class="diff_time" v-else>{{ data.item.diff_global }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ["coureurs", "index_po", "sexeFilter"],
  data() {
    return {
      hasLoaded: false,
      scrollIntervals: [],
      fields: [
        {
          key: "classement_global",
          sortable: false,
          label: this.$t("clt"),
        },
        {
          key: "nom",
          sortable: false,
          label: this.$t("nom_prenom"),
        },
        {
          key: "temps_course",
          sortable: false,
          label: this.$t("temps_course"),
        },
        {
          key: "heure_passage",
          sortable: false,
          label: this.$t("heure_passage"),
        },
        {
          key: "classement_sexe",
          sortable: false,
          label: this.$t("clt_sexe"),
        },
        {
          key: "classement_cat",
          sortable: false,
          label: this.$t("clt_cat"),
        },
      ],
    };
  },
  watch: {
    sexeFilter() {
      if (this.sexeFilter != "") {
        this.fields = [
          {
            key: "classement_sexe",
            sortable: false,
            label: this.$t("clt_sexe"),
          },
          {
            key: "nom",
            sortable: false,
            label: this.$t("nom_prenom"),
          },
          {
            key: "temps_course",
            sortable: false,
            label: this.$t("temps_course"),
          },
          {
            key: "heure_passage",
            sortable: false,
            label: this.$t("heure_passage"),
          },
          {
            key: "classement_global",
            sortable: false,
            label: this.$t("clt"),
          },
          {
            key: "classement_cat",
            sortable: false,
            label: this.$t("clt_cat"),
          },
        ];
      } else {
        this.fields = [
          {
            key: "classement_global",
            sortable: false,
            label: this.$t("clt"),
          },
          {
            key: "nom",
            sortable: false,
            label: this.$t("nom_prenom"),
          },
          {
            key: "temps_course",
            sortable: false,
            label: this.$t("temps_course"),
          },
          {
            key: "heure_passage",
            sortable: false,
            label: this.$t("heure_passage"),
          },
          {
            key: "classement_sexe",
            sortable: false,
            label: this.$t("clt_sexe"),
          },
          {
            key: "classement_cat",
            sortable: false,
            label: this.$t("clt_cat"),
          },
        ];
      }
    },
    coureurs(from, to) {
      var _this = this;
      var container_tableau_id = ".table_passages_" + this.index_po;
      var container_tableau = this.$el.querySelector(container_tableau_id);
      if (container_tableau.scrollTop > 100 && from.length - to.length > 20) {
        var timeoutObject = setTimeout(function () {
          container_tableau.scrollTop = container_tableau.scrollHeight;
          clearTimeout(this);
        }, 500);
      }
    },
  },
  methods: {
    clearScrollIntervals() {
      for (var i = 0; i < this.scrollIntervals.length; i++) {
        clearInterval(this.scrollIntervals[i]);
      }
      this.scrollIntervals = [];
    },
    countdownRefresh() {
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.clearScrollIntervals();
        _this.scroll_to_bottom();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_live);
      this.scrollIntervals.push(intervalObject);
    },
    userScroll(e) {
      if (e.target.scrollTop === 0) {
        this.$emit("scrollToLoadMore");
      }
    },
    scroll_to_bottom() {
      var container_tableau_id = ".table_passages_" + this.index_po;
      var container_tableau = this.$el.querySelector(container_tableau_id);
      if (container_tableau.scrollTop > container_tableau.scrollHeight - 600) {
        container_tableau.scrollTop = container_tableau.scrollHeight;
      }
    },
    openFicheCoureur(item, index) {
      var fiche_path = "fiche/" + item.id_coureur;
      this.$router.push({ path: fiche_path });
    },
    row_femme(item, type) {
      if (!item || type !== "row") return;
      if (item.sexe === "F") return "row-femme";
    },
  },

  mounted() {
    var _this = this;
    var timeoutObject = setTimeout(function () {
      var container_tableau_id = ".table_passages_" + _this.index_po;
      var container_tableau = _this.$el.querySelector(container_tableau_id);
      container_tableau.scrollTop = container_tableau.scrollHeight;
      clearTimeout(this);
    }, 500);
    this.clearScrollIntervals();
    var _this = this;
    this.scroll_to_bottom();
    this.countdownRefresh();
  },
};
</script>

<style lang="sass" scoped>
</style>